export const home = {
  hero: {
    subtitle: 'WEALTH ENGINEERING',
    title: 'FGT Capital — Technical Rigor and Governance.',
    description: 'Financial architecture for wealth decisions through regulated consortiums. Method, modeling and execution.'
  },
  manifesto: {
    line1: 'Wealth is not improvised.',
    line2: 'It is designed.',
    line3: 'No promises. With structure.'
  },
  pillars: {
    title: 'Our Pillars',
    engineering: {
      title: 'Engineering',
      description: 'Technical modeling of wealth scenarios with structural analysis of variables, regulations and group dynamics.'
    },
    governance: {
      title: 'Governance',
      description: 'Absolute transparency about risks, deadlines and costs. No promises of contemplation or guaranteed returns.'
    },
    execution: {
      title: 'Execution',
      description: 'Disciplined monitoring from diagnosis to credit utilization, with control of each stage.'
    }
  },
  portfolio: {
    eyebrow: 'PORTFOLIO',
    title: 'Portfolio',
    subtitle: 'Selected cases that represent the patrimonial focus and technical capability of FGT Capital.',
    secondaryNote: 'In addition to the featured residential and automotive cases, FGT also structures specific wealth demands across complementary areas — corporate real estate, niche assets, and personal-use patrimony.',
    categories: {
      highlights: 'Highlights',
      residential: 'Residential',
      automotive: 'Automotive',
      corporate: 'Corporate',
      lifestyle: 'Lifestyle'
    },
    projects: [
      {
        id: 1,
        category: 'residential',
        featured: true,
        title: 'Alphaville Penthouse',
        location: 'Av. Ômega, 174 — Alphaville, Barueri, SP',
        value: 'R$ 3,450,000',
        creditRef: 'R$ 3,450,000',
        parcRef: 'R$ 17,805.00',
        prazoRef: '237 months',
        condominioRef: 'R$ 3,577/mo',
        description: 'Wealth structuring for duplex penthouse acquisition in a high-standard condominium via real estate consortium.',
        tags: ['Patrimonial Acquisition', 'High Standard', 'Duplex Penthouse'],
        details: { area: '215m²', type: 'Duplex Penthouse' }
      },
      {
        id: 5,
        category: 'residential',
        featured: true,
        title: 'Riviera de São Lourenço Apartment',
        location: 'Módulo 07 — Bertioga, SP',
        value: 'R$ 6,200,000',
        creditRef: 'R$ 6,200,000',
        parcRef: 'R$ 38,500.00',
        prazoRef: '200 months',
        description: 'Wealth engineering for high-standard apartment acquisition on the northern coast of São Paulo, with seasonality and rental potential analysis.',
        tags: ['Coastal', 'Second Home', 'High Standard'],
        details: { area: '141m²', type: 'Beach Apartment' }
      },
      {
        id: 13,
        category: 'residential',
        featured: true,
        title: 'Penthouse in Jardim Europa',
        location: 'Avenida Eusébio Matoso, 218 — Jardim Europa, São Paulo - SP',
        value: 'R$ 7,400,000',
        creditRef: 'R$ 7,400,000',
        parcRef: 'R$ 48,216.00',
        prazoRef: '200 months',
        description: 'Premium penthouse at the corner of Av. Eusébio Matoso and Av. Faria Lima — one of the most prestigious addresses in São Paulo. 228m², 3 suites and 5 parking spots. Full financial structuring via consortium with patrimonial curation.',
        tags: ['Penthouse', 'Jardim Europa', 'Faria Lima'],
        details: { area: '228m²', bedrooms: '3 bedrooms / 3 suites', parking: '5 parking spots', type: 'Penthouse' }
      },
      {
        id: 14,
        category: 'residential',
        featured: true,
        title: 'House at Condomínio Terras de São José',
        location: 'Itu, SP',
        value: 'R$ 6,500,000',
        creditRef: 'R$ 6,500,000.00',
        parcRef: 'R$ 40,250.00',
        prazoRef: '200 months',
        description: 'Patrimonial structuring for residence acquisition in a premium interior condominium, with second home, seasonality and appreciation potential analysis.',
        tags: ['Second Home', 'Premium Condominium', 'São Paulo Interior'],
        details: { area: '369m²', type: 'Condominium House' }
      },
      {
        id: 16,
        category: 'residential',
        featured: true,
        title: 'House at Condomínio Terras de São José 766m²',
        location: 'Itu, SP',
        value: 'R$ 12,000,000',
        creditRef: 'R$ 12,000,000.00',
        parcRef: 'R$ 76,860.00',
        prazoRef: '225 months',
        description: 'Patrimonial structuring for high-end house acquisition at Condomínio Terras de São José, 3 bedrooms, 3 suites, 40 parking spaces and 766m² private area in Itu/SP.',
        tags: ['Premium Condominium', 'São Paulo Interior', 'High Standard'],
        details: { area: '766m²', type: 'Condominium House' }
      },
      {
        id: 6,
        category: 'automotive',
        featured: true,
        title: 'BMW 320i GP 2026',
        location: 'São Paulo, SP',
        value: 'R$ 375.000,00',
        creditRef: 'R$ 375.000,00',
        parcRef: 'R$ 5.600,00',
        prazoRef: '78 meses',
        description: 'Premium sedan with high performance, equipped with a 2.0 Turbo engine (B48) delivering 184 hp and ZF 8-speed automatic transmission. Focused on technology and sophistication, featuring the Curved Display (integrated screens), rear-wheel drive, 19" alloy wheels and semi-autonomous driving features like Park Assist and ACC.',
        tags: ['Premium Vehicle', 'Capital Efficiency', 'Strategic'],
        details: { vehicleType: 'Sedan', type: 'Automobile' }
      },
      {
        id: 10,
        category: 'residential',
        featured: false,
        title: 'House in Tamboré',
        location: 'Santana de Parnaíba, SP',
        value: 'R$ 3,800,000',
        creditRef: 'R$ 3,800,000',
        parcRef: 'R$ 47,500',
        prazoRef: '80 months',
        description: 'Wealth structuring for house acquisition in a premium gated condominium in Tamboré, with liquidity analysis and capital preservation strategy.',
        tags: ['Gated Condominium', 'Prime Location', 'Liquidity Preservation'],
        details: { area: '480m²', type: 'House in Condominium', completion: '14 months' }
      },
      {
        id: 11,
        category: 'residential',
        featured: false,
        title: 'Residence in Aldeia da Serra',
        location: 'Barueri, SP',
        value: 'R$ 5,200,000',
        creditRef: 'R$ 5,200,000',
        parcRef: 'R$ 65,000',
        prazoRef: '80 months',
        description: 'Patrimonial acquisition in one of the most valued condominiums on the Alphaville axis, focused on residential sophistication and long-term asset protection.',
        tags: ['High Standard', 'Exclusivity', 'Appreciation'],
        details: { area: '620m²', type: 'High-End Residence', completion: '18 months' }
      },
      {
        id: 12,
        category: 'residential',
        featured: false,
        title: 'Apartment in Moema Pássaros',
        location: 'São Paulo, SP',
        value: 'R$ 2,900,000',
        creditRef: 'R$ 2,900,000',
        parcRef: 'R$ 36,250',
        prazoRef: '80 months',
        description: 'Credit structuring for high-standard apartment acquisition in Moema, a prime São Paulo neighborhood with consistent liquidity and consolidated patrimonial profile.',
        tags: ['Prime Location', 'Liquidity', 'Residential Sophistication'],
        details: { area: '190m²', type: 'Apartment', completion: '12 months' }
      },
      {
        id: 15,
        category: 'residential',
        featured: false,
        title: 'Property in Vila Nova Conceição',
        location: 'São Paulo, SP',
        value: 'R$ 4,300,000',
        creditRef: 'R$ 4,300,000',
        parcRef: 'R$ 53,750',
        prazoRef: '80 months',
        description: 'Patrimonial acquisition in a prime São Paulo neighborhood with historical high liquidity, consolidated residential profile and permanent high-standard demand.',
        tags: ['Patrimonial Acquisition', 'High Liquidity', 'Prime Location'],
        details: { area: '260m²', type: 'High-Standard Apartment', completion: '16 months' }
      },
      {
        id: 40,
        category: 'residential',
        featured: false,
        title: 'House in Gated Community — Jardim Marajoara',
        location: 'Jardim Marajoara, São Paulo/SP',
        value: 'R$ 2,530,000',
        creditRef: 'R$ 2,530,000',
        parcRef: 'R$ 35,000',
        prazoRef: '80 months',
        condominioRef: 'R$ 1,484/mo',
        description: 'Patrimonial structuring for the acquisition of a family-oriented condominium house with generous floor area in a consolidated location in the south zone of São Paulo.',
        tags: ['Patrimonial Acquisition', 'High Standard', 'Condominium House'],
        details: { area: '380m²', type: 'Condominium House' }
      },
      {
        id: 41,
        category: 'residential',
        featured: false,
        title: 'Residence in Vila Sofia',
        location: 'Vila Sofia, São Paulo/SP',
        value: 'R$ 1,850,000',
        creditRef: 'R$ 1,850,000',
        parcRef: 'R$ 27,500',
        prazoRef: '80 months',
        condominioRef: 'R$ 1,336/mo',
        iptuRef: 'R$ 298/mo',
        description: 'Patrimonial acquisition of a residence in a consolidated residential neighborhood, with an urban high-standard profile and strong family orientation.',
        tags: ['Residential', 'Family Patrimony', 'Consolidated Location'],
        details: { area: '280m²', type: 'Single-Family Residence' }
      },
      {
        id: 42,
        category: 'residential',
        featured: false,
        title: 'Condominium House in Vila Sofia',
        location: 'Vila Sofia, São Paulo/SP',
        value: 'R$ 2,400,000',
        creditRef: 'R$ 2,400,000',
        parcRef: 'R$ 38,750',
        prazoRef: '80 months',
        condominioRef: 'R$ 1,590/mo',
        description: 'Structuring for the acquisition of a condominium house with a sophisticated residential design, combining privacy, security and family functionality.',
        tags: ['Patrimonial Acquisition', 'High Standard', 'Condominium House'],
        details: { area: '420m²', type: 'Condominium House' }
      },
      {
        id: 43,
        category: 'residential',
        featured: false,
        title: 'Family House in Jardim Marajoara',
        location: 'Jardim Marajoara, São Paulo/SP',
        value: 'R$ 2,950,000',
        creditRef: 'R$ 2,950,000',
        parcRef: 'R$ 31,250',
        prazoRef: '80 months',
        iptuRef: 'R$ 3,090/yr',
        description: 'Patrimonial planning for the acquisition of a spacious family house in a neighborhood with a strong family and high-standard residential profile.',
        tags: ['Residential', 'Family Patrimony', 'High Standard'],
        details: { area: '340m²', type: 'Single-Family House' }
      },
      {
        id: 44,
        category: 'residential',
        featured: false,
        title: 'Condominium House in Alto da Boa Vista',
        location: 'Alto da Boa Vista, São Paulo/SP',
        value: 'R$ 3,800,000',
        creditRef: 'R$ 3,800,000',
        parcRef: 'R$ 47,500',
        prazoRef: '80 months',
        description: 'Patrimonial acquisition of a condominium residence in one of the most elegant and consolidated areas of the south zone of São Paulo.',
        tags: ['Patrimonial Acquisition', 'High Standard', 'Condominium House'],
        details: { area: '460m²', type: 'Condominium House' }
      },
      {
        id: 2,
        category: 'corporate',
        featured: false,
        title: 'Alphaville Commercial Suite',
        location: 'Alameda Grajaú, 129 — Alphaville, Barueri — SP',
        value: 'R$ 3,000,000',
        creditRef: 'R$ 3,000,000',
        parcRef: 'R$ 15,830',
        prazoRef: '240 months',
        condominioRef: 'R$ 4,251',
        description: 'Commercial suite for sale at Ed. Murano Business Office in Alphaville/SP, 200 m² usable area with 4 parking spaces.',
        tags: ['Commercial Suite', 'Alphaville', 'Murano Business Office'],
        details: { area: '201m²', type: 'Commercial Suite', bathrooms: '4 bathrooms', parking: '4 spaces' }
      },
      {
        id: 20,
        category: 'corporate',
        featured: false,
        title: 'Medical Commercial Suite — Vila Mariana',
        location: 'Rua Domingos De Morais, 2187 — Vila Mariana, São Paulo/SP',
        value: 'R$ 1,674,720',
        creditRef: 'R$ 1,674,720',
        parcRef: 'R$ 11,825.00',
        prazoRef: '225 months',
        condominioRef: 'R$ 1,979',
        description: 'Premium office space at Ez-Mark Vila Mariana building, a contemporary architecture award-winning building with architectural design by Carlos Ott/DWA; landscaping by Benedito Abbud and decoration by Priscilla Zarzur. High-end finishing with excellent use of spacious and airy space with a beautiful view of the neighborhood. Spectacular location next to Shopping Metrô Santa Cruz, with access to the blue line Metro and just minutes from the Av. Paulista axis. About the property: 24-hour concierge with Security and Messenger service.',
        tags: ['Medical Commercial Suite', 'Vila Mariana', 'Ez-Mark'],
        details: { area: '104m²', type: 'Medical Commercial Suite', bathrooms: '1 bathroom', parking: '2 spaces' }
      },
      {
        id: 21,
        category: 'corporate',
        featured: false,
        title: 'Commercial Store — Moema',
        location: 'São Paulo, SP',
        value: 'R$ 2,400,000',
        creditRef: 'R$ 2,400,000',
        parcRef: 'R$ 9,645.00',
        prazoRef: '240 months',
        description: 'Financial engineering for retail store acquisition in a prime Moema address, with rental income and patrimonial appreciation analysis.',
        tags: ['Commercial Property', 'Prime Location', 'Appreciation'],
        details: { area: '320m²', type: 'Commercial Store' }
      },
      {
        id: 22,
        category: 'corporate',
        featured: false,
        title: 'Commercial Suite — Av. Chucri Zaidan',
        location: 'São Paulo, SP',
        value: 'R$ 3,200,000',
        creditRef: 'R$ 3,200,000',
        parcRef: 'R$ 40,000',
        prazoRef: '80 months',
        description: 'Acquisition of a corporate suite in the Chucri Zaidan financial corridor, with efficient credit structuring and total cost analysis.',
        tags: ['Corporate', 'Financial District', 'Capital Efficiency'],
        details: { area: '200m²', type: 'Corporate Suite', completion: '20 months' }
      },
      {
        id: 23,
        category: 'corporate',
        featured: false,
        title: 'Commercial Ensemble — Itaim Bibi',
        location: 'São Paulo, SP',
        value: 'R$ 4,600,000',
        creditRef: 'R$ 4,600,000',
        parcRef: 'R$ 57,500',
        prazoRef: '80 months',
        description: 'Patrimonial structuring for corporate ensemble acquisition in Itaim Bibi, one of the most valued business addresses in São Paulo.',
        tags: ['Corporate Ensemble', 'Premium Address', 'Business Patrimony'],
        details: { area: '340m²', type: 'Commercial Ensemble', completion: '22 months' }
      },
      {
        id: 24,
        category: 'corporate',
        featured: false,
        title: 'Corporate Suite — Brooklin',
        location: 'São Paulo, SP',
        value: 'R$ 2,100,000',
        creditRef: 'R$ 2,100,000',
        parcRef: 'R$ 26,250',
        prazoRef: '80 months',
        description: 'Financial engineering for corporate suite acquisition in Brooklin, focused on cash preservation and total occupancy cost efficiency.',
        tags: ['Own Headquarters', 'Preserved Cash Flow', 'Strategic'],
        details: { area: '150m²', type: 'Corporate Suite', completion: '16 months' }
      },
      {
        id: 25,
        category: 'corporate',
        featured: false,
        title: 'Premium Office — Moema Pássaros',
        location: 'São Paulo, SP',
        value: 'R$ 2,700,000',
        creditRef: 'R$ 2,700,000',
        parcRef: 'R$ 33,750',
        prazoRef: '80 months',
        description: 'Patrimonial acquisition of a premium professional office in Moema Pássaros, a prime neighborhood with a consolidated high-end clientele profile.',
        tags: ['Premium Office', 'Prime Location', 'Patrimonial Acquisition'],
        details: { area: '140m²', type: 'Professional Office', completion: '18 months' }
      },
      {
        id: 3,
        category: 'lifestyle',
        featured: false,
        title: 'BMW G 1300 GS',
        location: 'São Paulo, SP',
        value: 'R$ 140,000',
        creditRef: 'R$ 140,000',
        parcRef: 'R$ 1,390.00',
        prazoRef: '118 months',
        description: 'The BMW R 1300 GS 2026 is the brand\'s new benchmark in the trail segment, focused on weight reduction (-17 kg) and high performance. Equipped with a 1,300 cc Boxer engine with 145 hp, it stands out for its new frame, EVO Telelever suspension, advanced technology (ACC radar) and renewed design.',
        tags: ['Motorcycle', 'Lifestyle Asset', 'Consortium'],
        details: { type: 'Adventure Motorcycle' }
      },
      {
        id: 4,
        category: 'lifestyle',
        featured: false,
        title: 'Road Bike',
        location: 'São Paulo, SP',
        value: 'R$ 65,000',
        creditRef: 'R$ 65,000',
        parcRef: 'R$ 1,200',
        prazoRef: '80 months',
        description: 'Financial planning for acquisition of a high-performance Orbea Orca Road Bike, a benchmark in cycling performance and technology.',
        tags: ['Road Bike', 'Lifestyle Asset', 'Consortium'],
        details: { type: 'Road Bike' }
      },
      {
        id: 30,
        category: 'lifestyle',
        featured: false,
        title: 'Jet Ski — Personal Watercraft',
        location: 'Brazil',
        value: 'R$ 85,000',
        creditRef: 'R$ 85,000',
        parcRef: 'R$ 1,100',
        prazoRef: '80 months',
        description: 'Credit structuring for high-performance Jet Ski acquisition — a premium lifestyle asset with capital-efficient consortium approach.',
        tags: ['Jet Ski', 'Lifestyle Asset', 'Aquatic Lifestyle'],
        details: { area: '—', type: 'Jet Ski', completion: '10 months' }
      }
    ]
  },
  methodology: {
    eyebrow: 'INTERACTIVE METHODOLOGY',
    title: 'From Analysis to Execution',
    subtitle: 'Structured process that ensures technical rigor at each stage of the wealth journey.',
    steps: [
      {
        number: '01',
        title: 'Wealth Diagnosis',
        description: 'Complete mapping of profile, objectives and investment capacity.',
        benefit: 'For decisions grounded in real data, not assumptions.',
        details: 'Analysis of income, current wealth, specific objectives and time horizon.',
        icon: 'search'
      },
      {
        number: '02', 
        title: 'Structural Analysis',
        description: 'Technical evaluation of groups, regulations and compatible administrators.',
        benefit: 'To understand real conditions before any financial commitment.',
        details: 'Study of regulations, group history and administrator analysis.',
        icon: 'analytics'
      },
      {
        number: '03',
        title: 'Scenario Modeling',
        description: 'Base scenario projection and stress testing with market variables.',
        benefit: 'For clearer acquisition planning with full visibility of possible paths.',
        details: 'Monte Carlo simulations, sensitivity analysis and stressed scenarios.',
        icon: 'calculator'
      },
      {
        number: '04',
        title: 'Controlled Execution',
        description: 'Implementation with continuous monitoring until credit utilization.',
        benefit: 'So each stage unfolds as planned, with no operational surprises.',
        details: 'Assembly monitoring, deadline control and risk management.',
        icon: 'checkmark'
      }
    ]
  },
  solutions: {
    title: 'Solutions',
    real_estate: {
      category: 'REAL ESTATE',
      title: 'Real Estate Acquisition',
      description: 'Credit structuring for residential and commercial property acquisition via regulated consortium.'
    },
    construction: {
      category: 'CONSTRUCTION',
      title: 'Construction and Renovation',
      description: 'Financial planning for works, renovations and expansions with disbursement governance.'
    },
    planning: {
      category: 'PLANNING',
      title: 'Wealth Planning',
      description: 'Long-term architecture for wealth formation and protection with technical discipline.'
    },
    corporate: {
      category: 'CORPORATE',
      title: 'Corporate Structuring',
      description: 'Solutions for asset acquisition, own headquarters and corporate expansion with structured method.'
    },
    letters: {
      category: 'CONTEMPLATED',
      title: 'Contemplated Letters',
      description: 'Technical curation, document validation and operational risk analysis for contemplated letters.'
    }
  },
  process: {
    title: 'How It Works',
    step1: {
      title: 'Diagnosis',
      description: 'Complete mapping of wealth profile, objectives and client investment capacity.'
    },
    step2: {
      title: 'Structural Analysis',
      description: 'Technical evaluation of groups, regulations and administrators compatible with identified profile.'
    },
    step3: {
      title: 'Scenario Modeling',
      description: 'Base scenario projection and stress test for visualization of structural risks and opportunities.'
    },
    step4: {
      title: 'Execution and Monitoring',
      description: 'Strategy implementation with continuous monitoring until complete credit utilization.'
    }
  },
  governance: {
    text: 'There is no guarantee of contemplation. There is no promise of fixed return. Dynamics depend on administrator regulation and group composition. All variables are presented with technical transparency.'
  },
  finalCta: {
    title: 'Ready to Structure your Wealth?',
    description: 'Schedule a strategic diagnosis without commitment and understand how wealth engineering can apply to your case.'
  },
  diagBanner: {
    eyebrow: 'STRATEGIC DIAGNOSIS',
    title: 'Understand your wealth potential in one conversation.',
    description: 'No commitment. No promises. Just technical clarity about what consortium can or cannot do for your case.',
    item1: 'Personalized analysis of your profile',
    item2: 'Scenario modeling with real data',
    item3: 'Return within 1 business day',
    cta: 'Schedule Free Diagnosis',
    disclaimer: 'No commitment. Free and confidential.'
  },
  testimonials: {
    eyebrow: 'REAL CASES',
    title: 'What our clients say',
    subtitle: 'Anonymous reports from clients who went through the wealth engineering process.',
    items: [
      {
        quote: 'I had tried financing twice and could not get approval. FGT mapped my profile, modeled scenarios and structured a consortium entry I would never have thought of alone. Today I have the property.',
        profile: 'Entrepreneur, 41 years — São Paulo, SP',
        tag: 'Real Estate Acquisition',
        credit: 'R$ 480,000'
      },
      {
        quote: 'What surprised me was the transparency. They showed me exactly the risks, real deadlines and stress scenarios. There was no promise — and that gave me more confidence than any false guarantee.',
        profile: 'Doctor, 38 years — Belo Horizonte, MG',
        tag: 'Wealth Planning',
        credit: 'R$ 320,000'
      },
      {
        quote: 'I needed own headquarters for the company without compromising cash flow. The structuring was surgical: corporate consortium with installments compatible with our revenue. Result: headquarters paid off in 4 years.',
        profile: 'Partner-director, 47 years — Campinas, SP',
        tag: 'Corporate Structuring',
        credit: 'R$ 1,200,000'
      },
      {
        quote: 'I wanted to build, but real estate credit interest made the project unfeasible. The diagnosis showed that construction consortium was the most efficient alternative for my 36-month horizon.',
        profile: 'Architect, 34 years — Florianópolis, SC',
        tag: 'Construction and Renovation',
        credit: 'R$ 260,000'
      },
      {
        quote: 'I received a third-party contemplated letter and did not know if it was safe. FGT did all document validation and risk analysis before I signed anything. Clean process, no surprises.',
        profile: 'Investor, 55 years — Rio de Janeiro, RJ',
        tag: 'Contemplated Letter',
        credit: 'R$ 750,000'
      },
      {
        quote: 'Three children, dispersed wealth and no planning. The diagnosis was the turning point: I understood for the first time how to organize and protect what I built in 20 years of work.',
        profile: 'Lawyer, 52 years — Curitiba, PR',
        tag: 'Wealth Planning',
        credit: 'R$ 900,000'
      }
    ],
    disclaimer: 'Anonymous testimonials with altered data to preserve client privacy. Individual results vary according to profile and market conditions.'
  },
  useCases: {
    eyebrow: 'CONTEMPLATED LETTER',
    title: 'When it may make sense',
    subtitle: 'A contemplated letter is a specific instrument with distinct technical advantages and limitations. Understanding when it fits your objective is the starting point of any analysis.',
    cta: 'Start diagnosis',
    items: [
      {
        label: 'Real Estate Acquisition',
        title: 'High-value property with lower total cost',
        description: 'For those seeking significant real estate credit with a lower total cost than traditional financing, preserving liquidity throughout the process.'
      },
      {
        label: 'High-Value Vehicle',
        title: 'Capital efficiency in vehicle acquisition',
        description: 'When cost-benefit matters more than speed of acquisition — access to credit with no interest embedded in the contract.'
      },
      {
        label: 'Pre-Contemplated Credit',
        title: 'Wealth structuring with immediate access',
        description: 'Already-contemplated letters offer immediate credit access, with risk analysis, document validation and projected real cost provided by FGT.'
      },
      {
        label: 'Comparative Assessment',
        title: 'Before deciding between alternatives',
        description: 'A technical diagnosis that reveals the real cost of each path: contemplated letter, consortium or financing, applied to your specific case.'
      }
    ]
  },
  cartaCuration: {
    eyebrow: 'TECHNICAL CURATION',
    title: 'FGT does not sell a letter.\nIt evaluates, selects, structures and guides.',
    subtitle: 'Every contemplated letter goes through a rigorous analysis process before any client recommendation. Our work begins well before the signature.',
    cta: 'View available letters',
    statement: 'A contemplated letter is a financial instrument with specific regulation and real operational risks. Our curation exists so the client accesses the right instrument, in the right conditions, with full clarity about what is being contracted.',
    pillars: [
      {
        label: '01',
        title: 'Document Validation',
        description: 'We verify the origin, regularity and backing of each letter before any formal recommendation.'
      },
      {
        label: '02',
        title: 'Fit-to-Objective Analysis',
        description: 'We assess whether the letter is appropriate to the client\'s specific wealth objective, avoiding misaligned allocations.'
      },
      {
        label: '03',
        title: 'Cost and Risk Reading',
        description: 'We compare the total effective cost of the letter against available market alternatives, with full transparency.'
      },
      {
        label: '04',
        title: 'Operational Review',
        description: 'We analyze administrator, group regulation and transfer conditions before any formalization.'
      },
      {
        label: '05',
        title: 'Controlled Follow-up',
        description: 'We monitor each stage until credit utilization and asset regularization, with periodic reporting.'
      }
    ]
  },
  intentPathways: {
    eyebrow: 'STARTING POINT',
    title: 'Where to begin',
    note: 'Each diagnosis is conducted individually, without commitment. The goal is to determine whether a contemplated letter or regulated consortium is the right instrument for your case.',
    items: [
      {
        label: 'Contemplated Letter',
        title: 'I want to evaluate a contemplated letter',
        description: 'I have received a proposal or want to understand whether a letter is the best alternative for my wealth objective.'
      },
      {
        label: 'Real Estate Acquisition',
        title: 'I want to structure a real estate acquisition',
        description: 'I am looking for the most efficient financial architecture to acquire a high-value residential or commercial property.'
      },
      {
        label: 'Credit Alternatives',
        title: 'I want to compare credit alternatives',
        description: 'I need to understand the real differences between contemplated letter, consortium and financing for my specific case.'
      },
      {
        label: 'Wealth Planning',
        title: 'I want to define the best route for my patrimony',
        description: 'I have medium or long-term wealth objectives and want to structure them with method and governance.'
      }
    ]
  },
  comparative: {
    eyebrow: 'TECHNICAL ANALYSIS',
    title: 'Contemplated letter, consortium or financing?',
    subtitle: 'Each structure has distinct logic, cost and timing. The choice depends on the objective, horizon and financial profile of the client — not on preference.',
    cta: 'Understand contemplated letters',
    colDimension: 'Dimension',
    colCarta: 'Contemplated Letter',
    colConsortium: 'Consortium',
    colFinancing: 'Financing',
    disclaimer: 'This comparison is general and technical in nature. Specific conditions vary according to administrator, group, profile and market moment. Individual diagnosis is required for a precise assessment.',
    rows: [
      {
        dimension: 'Credit Access',
        carta: 'Immediate — credit already contemplated and available',
        consortium: 'Depends on bid or lottery draw',
        financing: 'Immediate, subject to credit approval'
      },
      {
        dimension: 'Total Cost',
        carta: 'Administration fee + market premium',
        consortium: 'Administration fee throughout the group term',
        financing: 'Compound interest over the entire operation'
      },
      {
        dimension: 'Flexibility',
        carta: 'High — credit use under buyer control',
        consortium: 'Restricted to group regulation',
        financing: 'Tied to the financed asset'
      },
      {
        dimension: 'Main Risk',
        carta: 'Document validation and letter origin',
        consortium: 'Uncertainty of contemplation timeline',
        financing: 'High financial cost over the long term'
      },
      {
        dimension: 'Ideal Profile',
        carta: 'Those who need credit now at a controlled cost',
        consortium: 'Those with flexible horizon and installment discipline',
        financing: 'Those who prioritize speed and accept interest costs'
      }
    ]
  }
};